export default "__VITE_ASSET__qvvQUzhs__";